import voorbeeldDivers from './voorbeeldDivers';

const diverse = [
  {
    name: 'Voorbeeld Divers',
    description: [
      'Een bijzonder 3D-object uit de categorie diverse, ideaal voor inspiratie of maatwerk.',
      'Neem contact op voor jouw eigen idee!'
    ],
    dimensions: '10x10x10cm',
    images: [
      // require('../../images/diverse/diverse_1A.png'), // voeg toe indien beschikbaar
    ],
    stl: '/products/diverse/voorbeeld-divers.stl',
    contactLink: '/contact?product=Voorbeeld%20Divers',
  },
  // Voeg hier meer diverse objecten toe
];

export default diverse; 